import { FC, useMemo } from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { Table, EditableCell } from '../../../components';
import { MobileMaterialsDelivered } from './MobileMaterialsDelivered';
import { IMaterialsDelivered, ReactSetState } from '../../../models';
import { CellProps } from 'react-table';
import { formatMoney } from '../../../helpers';

interface IMaterialsDeliveredProps {
  materialsDelivered: IMaterialsDelivered[];
  setMaterialsDelivered: ReactSetState<IMaterialsDelivered[]>;
  checklistLoading: boolean;
  isDisabled?: boolean;
}

export const MaterialsDelivered: FC<IMaterialsDeliveredProps> = ({
  setMaterialsDelivered,
  materialsDelivered,
  checklistLoading,
  isDisabled
}) => {
  const isMobile = useMediaQuery('(max-width: 960px)');

  const updateMyData = (
    materialsDelivered: IMaterialsDelivered,
    columnId: string,
    value: string,
    error?: boolean
  ) => {
    setMaterialsDelivered(old =>
      old.map((row, index) => {
        if (row.materialsDeliveredId === materialsDelivered.materialsDeliveredId) {
          return {
            ...materialsDelivered,
            [columnId]: value
          };
        }
        return row;
      })
    );
  };
  const columns = useMemo(() => {
    return [
      {
        Header: 'Description',
        accessor: 'description',
        sort: false
      },
      {
        Header: 'Unit',
        accessor: 'unit',
        sort: false
      },
      {
        Header: 'Price',
        accessor: 'unitPrice',
        sort: false,
        Cell: (props: CellProps<IMaterialsDelivered>) => (
          <>{props.cell.row.original.unitPrice ? formatMoney(props.cell.row.original.unitPrice) : ''}</>
        )
      },
      {
        Header: 'Qty Ordered',
        accessor: 'quantityOrdered',
        sort: false
      },
      {
        Header: 'Qty Received',
        accessor: 'quantityReceived',
        sort: false,
        Cell: (props: any) =>
          isDisabled ? <>{props.cell.row.original.quantityReceived}</> : <EditableCell {...props} />
      }
    ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDisabled]);
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Materials Delivered
      </Typography>
      <Table
        columns={columns}
        data={materialsDelivered}
        isLoading={checklistLoading}
        ResponsiveComponent={isMobile ? MobileMaterialsDelivered : undefined}
        mobileProps={{
          setMaterialsDelivered: setMaterialsDelivered
        }}
        useTableProps={{
          updateMyData,
          isDisabled
        }}
        hidePagination
      />
    </Box>
  );
};
